<!-- SUM UP -->
<ng-container *ngIf="hideSavingsPlan; else fundWithdrawal">
  <div class="header">
    <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.graph_box.title' | translate }}</h2>
    <app-ui-tooltip [content]="'sp.revamp.infoTooltip.legal' | translate" color="grey" size="small"></app-ui-tooltip>
  </div>
</ng-container>

<ng-template #fundWithdrawal>
  <h3>
    <span class="title">{{ 'sp.revamp.assetGraph.title' | translate }}</span>
    <app-ui-tooltip [content]="'sp.revamp.infoTooltip.legal' | translate" color="grey" size="small"></app-ui-tooltip>
  </h3>
</ng-template>

<app-savings-sum-up
  *ngIf="estimatedValues"
  [currentChip]="currentChip"
  [customerInvestment]="customerInvestment"
  [estimatedPeriod]="timeToRetirement"
  [estimatedValues]="estimatedValues"
  [kind]="currentAccount.kind"
  [language]="customer.language"
  [newMonthlyValue]="newMonthlyValue"
></app-savings-sum-up>

<div class="range-chart" #chartContainer>
  <svg></svg>
  <app-savings-chart-tooltip
    [currency]="currentAccount.currency"
    [kind]="currentAccount.kind"
    [language]="customer.language"
    [tooltipData]="tooltipData"
    (toggleDetails)="toggleDetails($event)"
  ></app-savings-chart-tooltip>
  <div class="timeline">
    <div>
      <b>{{ currentYear }}</b>
      <span>{{ 'sp.revamp.3a.graph.now' | translate }}</span>
    </div>
    <div>
      <span>{{ timeToRetirement }} {{ 'sp.revamp.3a.graph.' + (timeToRetirement > 1 ? 'years' : 'year') | translate }}</span>
    </div>
    <div>
      <b>{{ retirementYear }}</b>
      <span>{{ 'sp.revamp.3a.graph.retirement' | translate }}</span>
    </div>
  </div>
</div>

<!-- CHART CHIPS -->
<div class="deposit-title">{{ 'sp.revamp.3a.deposits.title' | translate }}</div>
<div class="deposit-chips">
  <div
    class="deposit-chips-item"
    *ngFor="let item of ['expectedCaseWithout', 'expectedCase']; let i = index"
    (click)="switchSelection(i); track(i)"
    [class.inactive]="currentChip !== i"
  >
    {{ 'sp.revamp.assetGraph.' + (i === 0 ? 'monthly' : 'yearly') | translate }}
  </div>
</div>

<div class="no-deposit" *ngIf="estimatedValues">
  <span class="rectangle"></span>
  <span
    [innerHTML]="
      'sp.revamp.3a.noDeposits.text'
        | translate: { value: estimatedValues.expectedWithout | translateNumber: customer?.language:customerInvestment?.currency }
    "
  ></span>
</div>

<!-- DEPOSIT INPUT and DIALOG -->
<app-savings-deposit-3a
  *ngIf="!hideSavingsPlan"
  [appLocation]="customer?.app_location"
  [currency]="customerInvestment?.currency"
  [language]="customer?.language"
  [inputError]="inputError"
  [newSavings]="newMonthlyValue"
  [originalSavings]="customerInvestment?.monthly_investment"
  [maximumInput]="maximumInput"
  [minimumInput]="minimumInput"
  [selectedChip]="currentChip"
  (changeValue)="onChangeValue($event)"
  (setDeposit)="onSetDeposit($event)"
></app-savings-deposit-3a>

<!-- MORE EXPLANATION -->
<app-social-proof
  *ngIf="estimatedValues"
  [currency]="customerInvestment?.currency"
  [estimatedPeriod]="timeToRetirement"
  [estimatedValues]="estimatedValues"
  [expectedPercentages]="expectedPercentages"
  [kind]="currentAccount.kind"
  [language]="customer?.language"
  [savingsPlanSocialProof]="savingsPlanSocialProof"
  [showDetails]="showDetails"
  [hideSavingsPlan]="hideSavingsPlan"
  (toggleDetails)="toggleDetails($event)"
></app-social-proof>
